<template>
	<div>
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="bg_gray study_my">
			<div class="w1200">
				<div class="flex famous_position">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/study" class="cl_gray">趣学习</router-link>  >  我的课程</p>
					</div>
					<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
				</div>
				<div class="my bg_white radius8 bs">
					<div class="my_title">
						<div class="practice_title f20px cl_dark">我的账户</div>
						<div class="account mat30">
							<img src="../../../static/account_bg.png" />
							<div class="account_r">
								<p class="f18px cl_dark">账户余额&nbsp;&nbsp;<span class="f26px cl_red">{{myInfo.balance}}</span></p>
								<router-link to="/payment" class="account_payment cl_white tc">充值</router-link>
							</div>
						</div>
					</div>
					<div class="my_cont mat60">
						<div class="practice_title f20px cl_dark">我的课程</div>
						<div class="my_nav tc mat30 mab30">
							<div class="my_nav_list bg_gray cl_gray" :class="{'on':navCur==1}" @click="navCheck(1)">课程列表</div>
							<div class="my_nav_list bg_gray cl_gray" :class="{'on':navCur==2}" @click="navCheck(2)">课程消费</div>
							<div class="my_nav_list bg_gray cl_gray" :class="{'on':navCur==3}" @click="navCheck(3)">充值记录</div>
						</div>
						<div class="my_cont">
							<div class="my_course" v-show="navCur==1">
								<div class="flex" style="flex-wrap: wrap;">
									<div class="my_course_list mab20 radius8 bs" v-for="(item,index) in course" :key="index">
										<router-link :to="{ path: '/video', query: { id: item.pack_id}}" class="my_course_list_top block clip f20px">{{item.pack_name}}</router-link>
										<div class="my_course_list_btm flex mat20">
											<div class="my_course_list_l f16px cl_gray">
												<div>
													<img src="../../../static/icon_time.png" class="mar5" />
													<p>更新时间：{{item.add_time}}</p>
												</div>
												<div class="mat5">
													<img src="../../../static/icon_person.png" class="mar5" />
													<p>主讲老师：{{item.teacher_name}}</p>
												</div>
												<!-- <div class="mat5">
													<img src="../../../static/icon_list.png" class="mar5" />
													<p>已上课时：<span class="cl_yel">{{item.already}}</span>/{{item.all}}</p>
												</div> -->
											</div>
											<router-link :to="{ path: '/video', query: { id: item.pack_id}}" class="my_course_list_r tc f16px cl_white">进入学习</router-link>
										</div>
									</div>
								</div>
								<div class="famous_page flex" v-if="course.length > 0">
									<div class="famous_page_l f16px cl_gray">共 {{total}} 条记录 页次：{{currentPage}}/{{Math.ceil(total/pageSize)}}页   {{pageSize}}条/页</div>
									<div class="famous_page_r cl_dark">
										<el-pagination background layout="prev, pager, next"
										@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
									</div>
								</div>
							</div>
							<div class="course_consume" v-show="navCur==2">
								<table class="consume_table" v-if="consume.length > 0">
									<thead class="f18px">
										<tr>
											<th width="260px">消费时间</th>
											<th width="260px">订单号</th>
											<th width="260px">订购课程</th>
											<th width="180px">消费金额</th>
											<th width="180px">支付方式</th>
										</tr>
									</thead>
									<tbody class="f16px cl_dark">
										<tr v-for="(item,index) in consume" :key="index">
											<td align="center"><p>{{item.pay_time}}</p></td>
											<td align="center"><p>{{item.order_no}}</p></td>
											<td align="center"><p>{{item.pack_name}}</p></td>
											<td align="center"><p class="cl_red"><i class="f26px">{{item.pay_money}}</i><span> 元</span></p></td>
											<td align="center"><p>{{item.payment_type == 1 ? '余额支付' : '' || item.payment_type == 2 ? '支付宝支付' : '' || item.payment_type == 3 ? '微信支付' : ''}}</p></td>
										</tr>
									</tbody>
								</table>
								<div class="famous_page flex" v-if="consume.length > 0">
									<div class="famous_page_l f16px cl_gray">共 {{total2}} 条记录 页次：{{currentPage2}}/{{Math.ceil(total2/pageSize2)}}页   {{pageSize2}}条/页</div>
									<div class="famous_page_r cl_dark">
										<el-pagination background layout="prev, pager, next"
										@current-change="handleCurrentChange2" :page-size="pageSize2" :current-page="currentPage2" :total="total2"></el-pagination>
									</div>
								</div>
							</div>
							<div class="record" v-show="navCur==3">
								<table class="consume_table" v-if="record.length > 0">
									<thead class="f18px">
										<tr>
											<th width="300px">消费时间</th>
											<th width="300px">订单号</th>
											<th width="300px">充值金额</th>
											<th width="300px">支付方式</th>
											<th width="240px">充值结果</th>
										</tr>
									</thead>
									<tbody class="f16px cl_dark">
										<tr v-for="(item,index) in record" :key="index">
											<td align="center"><p>{{item.add_time}}</p></td>
											<td align="center"><p>{{item.order_no}}</p></td>
											<td align="center"><p class="cl_red f26px">{{item.pay_money}}</p></td>
											<td align="center"><p>{{item.payment_type == 1 ? '余额支付' : '' || item.payment_type == 2 ? '支付宝支付' : '' || item.payment_type == 3 ? '微信支付' : ''}}</p></td>
											<td align="center"><p>{{item.status == 'done' ? '成功' : '失败'}}</p></td>
										</tr>
									</tbody>
								</table>
								<div class="famous_page flex" v-if="record.length > 0">
									<div class="famous_page_l f16px cl_gray">共 {{total3}} 条记录 页次：{{currentPage3}}/{{Math.ceil(total3/pageSize3)}}页   {{pageSize3}}条/页</div>
									<div class="famous_page_r cl_dark">
										<el-pagination background layout="prev, pager, next"
										@current-change="handleCurrentChange3" :page-size="pageSize3" :current-page="currentPage3" :total="total3"></el-pagination>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'my_course',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				subjectIndex: false, //学科分类显示
				studyNav: 5, //导航
				myInfo: {},
				public: {},
				money: 0,
				navCur: 1,
				course: [],
				currentPage: 1, //当前页数
				pageSize: 10, //每页数量
				total: 0, //总页数
				consume: [],
				currentPage2: 1, //当前页数
				pageSize2: 10, //每页数量
				total2: 0, //总页数
				record: [],
				currentPage3: 1, //当前页数
				pageSize3: 10, //每页数量
				total3: 0, //总页数
			}
		},
		mounted() {
			if (this.navCur == 1) {
				this.getCourse();
			} else if (this.navCur == 2) {
				this.getConsume();
			} else {
				this.getOrder();
			}
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			navCheck (e) {
				this.navCur = e;
				if (e == 1) {
					this.currentPage = 1;
					this.getCourse();
				} else if (e == 2) {
					this.currentPage2 = 1;
					this.getConsume();
				} else {
					this.getOrder();
				}
			},
			//课程历史记录
			getCourse () {
				this.$get("/api/course/get_user_pack_view_log_list",{
					token: localStorage.getItem("token"),
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.course = [];
					this.course = res.data.data;
					this.total = res.data.total;
				});
			},
			//已购课程记录
			getConsume () {
				this.$get("/api/user/get_user_pack_order_list",{
					token: localStorage.getItem("token"),
					page: this.currentPage2,
					limit: this.pageSize2,
				})
				.then(res => {
					this.consume = [];
					this.consume = res.data.data;
					this.total2 = res.data.total;
				});
			},
			//充值记录
			getOrder () {
				this.$get("/api/user/get_user_charge_order_list",{
					token: localStorage.getItem("token"),
					page: this.currentPage3,
					limit: this.pageSize3,
				})
				.then(res => {
					this.record = [];
					this.record = res.data.data;
					this.total3 = res.data.total;
				});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getCourse();
			},
			handleCurrentChange2: function(currentPage2){
				this.currentPage2 = currentPage2;
				this.getConsume();
			},
			handleCurrentChange3: function(currentPage3){
				this.currentPage3 = currentPage3;
				this.getOrder();
			},
		},
	}
</script>

<style>
</style>
